<template>
  <div v-show="show">
    <!-- 顶部banner开始 -->
    <div class="actTop_Banner" :style="bgstyle">
      <!-- <div class="actTop_BtnWrap">
				<a
					:href="actBtn.btnLink"
					class="actTop_Btn"
					v-for="(actBtn,index) in btnInfo"
					:key="index"
					v-text="actBtn.btnName"
					target="_blank"
				></a>
			</div> -->
    </div>
    <!-- 顶部banner结束 -->
  </div>
</template>
<script>
import './../../assets/css/reset.css';
import bus from '../../../bus';
export default {
	name: 'h5-banner-zero',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			bgurl: '头图链接地址',
			btnInfo: '功能按钮',
			btnName: '按钮名称',
			btnLink: '链接地址',
			showtype: '展示(1安卓,0 IOS)'
		}
	},
	props: {
		bgurl: {
			type: Object,
			default: function () {
				return {
					class: 'image',
					value: ''
				};
			}
		},
		showtype: {
			type: String,
			default: ''
		}
	},
	computed: {
		bgstyle () {
			if (this.bgurl.value !== '') {
				return 'background-image:url(' + this.bgurl.value + ')';
			} else {
				return '';
			}
		}
	},
	data () {
		return {
			show: true
		};
	},
	mounted () {
		bus.$on('showtype', val => {
			this.show = val === this.showtype;
		});
	}
};
</script>
<style scoped lang="scss">
//引入 scss 模块组件
@import "../../assets/scss/utils/include";
//@import "../../assets/scss/common.scss";
//组件 scss 变量（经常改动的）
$actTop-bg: url("//game.gtimg.cn/images/tgclub/hdtg/linshi/SUPERCORE-TOUTU.jpg"); //背景图或者背景色
$actTop-btnBg: #e27f7f; //操作按钮背景
$actTop-btnBgHover: null; //操作按钮背景 :hover 状态，背景图或者背景色，没有 :hover 状态的话要用 null 代替
$actTop-btnColor: #fff; //按钮文字颜色
$actTop-btnColorHover: null; //按钮文字颜色 :hover 状态，没有 :hover 状态的话要用 null 代替
.actTop_Banner {
  display: inline-block;
  height: 6.1rem;
  width: 7.5rem;
  background: $actTop-bg no-repeat center top;
  background-size: 7.5rem 6.1rem;
  margin: 0 auto;
}
.actTop_BtnWrap {
  text-align: center;
  padding-top: 6.9rem;
  font-size: 0;
}
.actTop_Btn {
  width: 2rem;
  height: 0.7rem;
  padding-top: 0.16rem;
  background: $actTop-btnBg;
  margin: 0 0.1rem;
  font-size: 0.28rem;
  color: $actTop-btnColor;
  @extend %inline-block;
  @include transition(all, 0.15, linear, 0);
  @if $actTop-btnBgHover {
    &:hover {
      background: $actTop-btnBgHover; //广告图操作按钮背景 :hover 状态背景
    }
  }
  @if $actTop-btnColorHover {
    &:hover {
      color: $actTop-btnColorHover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/banner/bannerZero.vue